<template>
  <div class="indexs" style="background-color: rgb(249, 249, 249);margin-top: 64px;">
    <div style="background-image: linear-gradient(rgb(204, 231, 255), rgb(249, 249, 249));">
      <!-- 轮播旧——王 -->
<!--      <div style="width: 100%;margin: 0;">-->
<!--        <div style="width: 1200px;margin: 0 auto;">-->
<!--          <el-carousel indicator-position="outside">-->
<!--            <el-carousel-item v-for="(item,index) in swiperList" :key="index">-->
<!--              <img :src="item.imgUrl" alt="" @click="goFor(item.type, item.typeId, item.linkUrl)" />-->
<!--            </el-carousel-item>-->
<!--          </el-carousel>-->
<!--        </div>-->
<!--      </div>-->
      <!-- 轮播旧——王 -->
      <!-- 搜索 -->
      <div class="search" style="padding-top: 18px;padding-bottom: 20px;height: 268px;margin-top: 18px">
        <div class="search-left">
          <div class="search-int">
            <input type="text" v-model="keywords" placeholder="搜索职位/公司/内容关键词">
            <div @click="search()">搜索</div>
          </div>
<!--          <div class="search-history">-->
<!--            <div>热搜：</div>-->
<!--            <div v-for="(item, index) in jobList" :key="index" @click="searchs(item)">{{ item }}</div>-->
<!--          </div>-->
        </div>
        <div class="search-img-indexvue searchImgOne_indexvue" style="position: relative;" @click="aaa()">
          <img style="width: 37px;height: 37px;" src="../assets/publicAccount.png" alt=""/>
          <div style="font-size: 14px;color: #070707;float:right;height: 37px;">
            <div style="height: 17px;line-height: 17px;margin-bottom: 4px">就业公众号</div>
            <div style="font-size: 12px;height: 16px;line-height: 16px">掌握最新求职动态</div>
          </div>
          <div  class="index-head-code_indexvue">
<!--            v-if="headIndex==3"-->
            <div class="index-head-code-triangle_indexvue"></div>
            <img class="index-head-code-img1_indexvue" src="../assets/publicAccount-IMG.jpg" alt="">
            <div class="index-head-code-div_indexvue">扫码关注公众号</div>
          </div>
<!--          <img style="width:80px;height:80px;position: absolute;top: 9px;right: 12px;" src="../assets/code.png" alt=""/>-->
        </div>

        <div class="search-img-indexvue searchImgTwo_indexvue" style="position: relative;" @click="aaa()">
          <img style="width: 37px;height: 37px;" src="../assets/smallProgram.png" alt=""/>
          <div style="font-size: 14px;float:right;color: #070707;height: 37px;margin-right: 12px">
            <div style="height: 17px;line-height: 17px;margin-bottom: 4px">就业小程序</div>
            <div style="font-size: 12px;height: 16px;line-height: 16px">随时随地找工作</div>
          </div>
          <!--          <img style="width:80px;height:80px;position: absolute;top: 9px;right: 12px;" src="../assets/code.png" alt=""/>-->
          <div  class="index-head-code_indexvue">
            <!--            v-if="headIndex==3"-->
            <div class="index-head-code-triangle_indexvue"></div>
            <img class="index-head-code-img1_indexvue" src="../assets/code.png" alt="">
            <div class="index-head-code-div_indexvue">扫码进入小程序</div>
          </div>
        </div>
      </div>
      <!-- 搜索 -->
    </div>
    <!-- 行业 -->

<!--轮播新-->
    <div style="height: 410px;width:1198px;margin: 0 auto;margin-top: -200px">
      <div class="job-menu">
        <ol class="job-menu__bj__list" style="width:100%;" ref='myOl'>
          <li class="job-menu__bj__item"
              style="left: 0px; z-index: 1; background-image: url(&quot;http://hzrc.oss-cn-shenzhen.aliyuncs.com/icon/20231106/153931540d3c3f.png&quot;);"></li>
          <li class="job-menu__bj__item"
              style="left: 0px; z-index: 0; background-image: url(&quot;http://hzrc.oss-cn-shenzhen.aliyuncs.com/icon/20231106/15395056856f98.png&quot;);"></li>
          <li class="job-menu__bj__item"
              style="left: 0px; z-index: 0; background-image: url(&quot;http://hzrc.oss-cn-shenzhen.aliyuncs.com/icon/20231106/1540092335473d.png&quot;);"></li>
        </ol>
        <ol class="job-menu__list job-menu__list--backdrop-filter">
          <li class="job-menu__item" v-for="(item,index) in tradeList" :key="index" @mouseenter="changePosition(index)">
            <nav>
              <a href="javascript:;" class="job-menu__item__name">{{ item.name }}</a>
              <i class="job-menu__item__arrow-right"></i>
              <div class="job-menu__sub">
                <h4 class="job-menu__sub__title">{{ item.name }}</h4>
                <div class="job-menu__sub__list">
                  <a href="javascript:;"  class="job-menu__sub__name"  v-for="(item,index) in tradeList[tradeListIndex].list" :key="index" @click="goSearchs(item.id,item.name)">{{ item.name }}</a>
                </div>
              </div>
            </nav>
          </li>
          <li class="job-menu__item" @click="goSearch()">
            <a href="#" class="job-menu__item__name">全部职类</a>
          </li>
        </ol>
      </div>
      <article class="banner-main">
        <div class="banner-main__wrap">
          <div class="swiper mySiper">
            <div class="swiper-wrapper swiper-no-swiping">
              <el-carousel trigger="click" arrow="never" style="width: 700px;height: 410px" v-on:change="changeFun">
                <el-carousel-item v-for="(item,index) in swiperList" :key="index" style="height: 410px">
                  <!--                  <img :src="item.imgUrl" alt="" @click="goFor(item.type, item.typeId, item.linkUrl)" />-->
                  <img :src="item.imgUrl" alt="" @click="goFor(item.type, item.typeId, item.linkUrl)"/>
                </el-carousel-item>
              </el-carousel>
            </div>
          </div>
        </div>
      </article>
      <div class="sccanCode_login">
        <div class="sccanCode_login_box" v-if="isLogin===false">
          <div class="sccanCode_title">微信登录</div>
          <div class="sccanCode_login_code">
            <img src="../assets/code.png" alt="">
            <div style="position: absolute;top: 0;left: 0;" class="sccanCode_refreshBtn" v-if="checkRefreshBtn==true">
              <div style="width: 100%;height: 100%;background: #fff;display: flex;align-items: center;justify-content: center;border-radius: 50%">
<!--                <img src="../assets/refresh_btn.png" alt="" >-->
                <img :src="url" alt="" v-if="iscodeBtn===false"  @click="getCode()" style="cursor: pointer">
                <img :src="url" alt=""  v-if="iscodeBtn===true"  >
              </div>
            </div>
          </div>
          <div class="refresh_title" v-if="iscodeBtn===false">请点击刷新二维码</div>
          <div class="refresh_title" style="color: #747474" v-if="iscodeBtn===false">使用微信【扫一扫】登录</div>
          <div class="refresh_title" v-if="iscodeBtn===true">使用微信【扫一扫】</div>
          <div class="refresh_title" style="color: #747474" v-if="iscodeBtn===true">使用【华帜就业】小程序登录</div>
        </div>

        <!--  个人中心-->
        <div class="sccanCode_login_box_role"  v-if="userInfo.identity===1&&isLogin===true||userInfo.identity===3&&isLogin===true||userInfo.identity===4&&isLogin===true||userInfo.identity===5&&isLogin===true">
          <img :src="userInfo.userPhoto"  style="margin-left: 16px;margin-right: 18px;"/>
          <div class="sccanCode_login_box_role-box-indexvue">
            <div>{{ userInfo.userName }}</div>
            <div style="margin-top: 16px;font-size: 16px;color: #3D3D3D;font-size: 14px;text-wrap: nowrap">
              <span v-if="userInfo.age !=='' && userInfo.age !== undefined">{{ userInfo.age }}岁</span>
              <span v-if="userInfo.age !=='' && userInfo.age !== undefined && userInfo.edu !=='' && userInfo.edu !== undefined">|</span>
              <span v-if="userInfo.edu">{{ userInfo.edu }}</span>
              <span v-if="userInfo.edu !=='' && userInfo.edu !== undefined && userInfo.condition !=='' && userInfo.condition !== undefined">|</span>
              <span v-if="userInfo.condition">{{ userInfo.condition }}</span>
            </div>
          </div>
          <div class="sccanCode_login_box_role_page">
            <div @click="resume()" style="color: #027FFE">个人简历</div>
            <div @click="personalCore()" style="background: #587CF7;color: #fff">个人中心</div>
          </div>
          <div class="sccanCode_login_box_role-right-box">
            <div style="float: left">
              <div class="sccanCode_role-right-boxs-indexvue" @click="enroll()" style="margin-left: 14px;margin-right: 12px">
                <img src="../assets/personalCore-icon2.png" />
                <div>我的投递</div>
              </div>
            </div>
            <div style="float: left">
              <div class="sccanCode_role-right-boxs-indexvue" @click="go()" >
                <img src="../assets/personalCore-icon3.png" style="margin-left: 0"/>
                <div>我的收藏</div>
              </div>
            </div>
          </div>
          <div class="ScancodeloginPersonal_phone">
            <img src="../assets/ScancodeloginPersonal_phone.png" alt="">
          </div>
        </div>
        <!--企业中心-->
        <div class="sccanCode_login_box_role" v-if="userInfo.identity===2&&isLogin===true">
          <img :src="userInfo.userPhoto"  style="margin-left: 16px;margin-right: 18px;"/>
          <div class="sccanCode_login_box_role-box-indexvue">
            <div>{{userInfo.companyName}}</div>
          </div>
          <div class="sccanCode_login_box_tipTime" v-if="userInfo.isCompanyVip==true">
            <div>{{ userInfo.companyVipName }}</div>
            <div>有效期至{{ userInfo.companyVipEndTime }}</div>
          </div>
          <div class="sccanCode_login_box_role_page" :style="userInfo.isCompanyVip==true?'padding:10px 13px':'padding:28px 13px'">
            <div style="color: #027FFE" @click="postRelease()">发布职位</div>
            <div style="background: #587CF7;color: #fff" @click="goss()">企业信息</div>
          </div>
          <div class="sccanCode_login_box_role-right-box">
            <div style="float: left">
              <div class="sccanCode_role-right-boxs-indexvue" @click="goJoblist()" style="margin-left: 14px;margin-right: 12px">
                <img src="../assets/Enterprise-icon1.png" />
                <div>职位列表</div>
              </div>
            </div>
            <div style="float: left">
              <div class="sccanCode_role-right-boxs-indexvue" @click="goCurriculumVitae()" >
                <img src="../assets/Enterprise-icon2.png" style="margin-left: 0"/>
                <div>简历管理</div>
              </div>
            </div>
          </div>
          <div class="ScancodeloginCompany_phone">
            <img src="../assets/ScancodeloginCompany_phone.png" alt="">
          </div>
        </div>
      </div>
    </div>
    <!--轮播新-->
    <!-- 行业旧 -->
<!--        <div class="industry">-->
<!--          <div class="industry-box" v-for="(item,index) in jobTradeList" :key="index"-->
<!--               :class="index==jobIndex?'index-actives':''" @mouseenter="changeIndustry(index)">-->
<!--            <img :src="item.imgUrl"/>-->
<!--            <div>{{ item.name }}</div>-->
<!--          </div>-->
<!--        </div>-->
    <!-- 行业旧 -->
    <!-- 岗位列表 -->
    <div style="width: 1200px;height: 59px;position: relative;margin: 0 auto;margin-top: 14px">
<!--      <img style="height: 59px;margin-bottom: 20px;width: 100%;margin-bottom: 18px;"-->
<!--           src="../assets/indexEnterprise.png"/>-->
      <div style="height: 59px;margin-bottom: 20px;width: 100%;background: linear-gradient(to right,#E0F0FF,#fff)"></div>
      <div style="font-size: 18px;position: absolute;top: 17px;left: 32px;font-weight: 550;">热招职位</div>
    </div>
    <!-- 岗位列表旧 -->
<!--    <div class="position" v-if="jobTradeList.length!==0" style="">-->
<!--      <div class="position-box" v-for="(item,index) in jobTradeList[jobIndex].jobList"-->
<!--           :class="index===2||index===5||index===8?'enterprise-box-active':''" :key="index">-->
<!--        <img src="../assets/indexJob.png" style="width:384px;height:214px;border-radius: 10px;" alt=""/>-->
<!--        <div class="position-top" @click="jobDetails(item.id)">-->
<!--          <div class="position-name">-->
<!--            <div>{{ item.name }}</div>-->
<!--            <div v-if="item.salary!==undefined&&item.salaryEnd!==undefined">{{ item.salary }}-{{ item.salaryEnd }}/月-->
<!--            </div>-->
<!--            <div v-if="item.salary==undefined&&item.salaryEnd!==undefined">{{ item.salaryEnd }}元以下</div>-->
<!--            <div v-if="item.salaryEnd==undefined&&item.salary!==undefined">{{ item.salary }}元以上</div>-->
<!--            <div v-if="item.isSalary==2">面议</div>-->
<!--          </div>-->
<!--          <div class="position-address">{{ item.address }}</div>-->
<!--          <div class="position-label">-->
<!--            <div v-for="(items,indexs) in item.tagList" :key="indexs">{{ items.title }}</div>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="position-bottom" @click="enterpriseDetails(item.companyInfo[0].id)">-->
<!--          <div class="position-bottom-img">-->
<!--            <img v-if="item.companyInfo[0].logo!=''&&item.companyInfo[0].logo!==undefined"-->
<!--                 :src="item.companyInfo[0].logo"/>-->
<!--            <img v-if="item.companyInfo[0].logo==''||item.companyInfo[0].logo==undefined" src="../assets/ping.png"/>-->
<!--          </div>-->
<!--          <div class="position-enterprise">-->
<!--            <div class="position-enterprise-name">{{ item.companyInfo[0].name }}</div>-->
<!--            <div class="position-enterprise-label">-->
<!--              <div>{{ item.companyInfo[0].nature }}</div>-->
<!--              <div>{{ item.companyInfo[0].scale }}</div>-->
<!--              <div>{{ item.companyInfo[0].trade }}</div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="position-box" @click="searchs()" style="margin-right: 0;cursor: pointer;">-->
<!--        <img src="../assets/indexJob.png" style="width:384px;height:214px;border-radius: 10px;" alt=""/>-->
<!--        <div style="position: absolute;top: 74px;left: 112px;">-->
<!--          <div style="margin-bottom: 12px;font-size: 20px;color:#828282;">更多行业性质职位</div>-->
<!--          <div style="text-align: center;color: #2892FE;">查看更多</div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--    <div class="morebtn_indexvue">更多职位</div>-->
    <!-- 岗位列表旧 -->
    <!-- 岗位列表新202311.6 -->
    <div class="position" v-if="jobList.length!==0" style="">
      <div class="position-box" v-for="(item,index) in jobList" :class="index===2||index===5||index===8?'enterprise-box-active':''" :key="index">
        <img src="../assets/indexJob.png" style="width:384px;height:214px;border-radius: 10px;" alt=""/>
        <div class="position-top" @click="jobDetails(item.id)">
          <div class="position-name">
            <div>{{ item.name }}</div>
<!--            <div v-if="item.salary!==undefined&&item.salaryEnd!==undefined">{{ item.salary }}-{{ item.salaryEnd }}/月
            </div>
            <div v-if="item.salary==undefined&&item.salaryEnd!==undefined">{{ item.salaryEnd }}元以下</div>
            <div v-if="item.salaryEnd==undefined&&item.salary!==undefined">{{ item.salary }}元以上</div>
            <div v-if="item.isSalary==2">面议</div>-->
            <div v-if="item.salaryName!=undefined&&item.salaryName!=null">{{ item.salaryName }}</div>
          </div>
          <div class="position-address">{{ item.address }}</div>
          <div class="position-label">
            <div v-for="(items,indexs) in item.tagList" :key="indexs">{{ items.title }}</div>
          </div>
        </div>
        <div class="position-bottom" v-if="item.companyInfo!==''&&item.companyInfo!==undefined" @click="enterpriseDetails(item.companyInfo[0].id)">
          <div class="position-bottom-img">
            <img v-if="item.companyInfo[0].logo!=''&&item.companyInfo[0].logo!==undefined"
                 :src="item.companyInfo[0].logo"/>
            <img v-if="item.companyInfo[0].logo==''||item.companyInfo[0].logo==undefined" src="../assets/ping.png"/>
          </div>
          <div class="position-enterprise">
            <div class="position-enterprise-name">{{ item.companyInfo[0].name }}</div>
            <div class="position-enterprise-label">
              <div>{{ item.companyInfo[0].nature }}</div>
              <div>{{ item.companyInfo[0].scale }}</div>
              <div>{{ item.companyInfo[0].trade }}</div>
            </div>
          </div>
        </div>
      </div>
<!--            <div class="position-box" @click="searchs()" style="margin-right: 0;cursor: pointer;">-->
<!--              <img src="../assets/indexJob.png" style="width:384px;height:214px;border-radius: 10px;" alt=""/>-->
<!--              <div style="position: absolute;top: 74px;left: 112px;">-->
<!--                <div style="margin-bottom: 12px;font-size: 20px;color:#828282;">更多行业性质职位</div>-->
<!--                <div style="text-align: center;color: #2892FE;">查看更多</div>-->
<!--              </div>-->
<!--            </div>-->
    </div>
    <div class="morebtn_indexvue" @click="searchs()">更多职位</div>
    <!-- 岗位列表新202311.6 -->
    <!-- 企业列表 -->
    <div class="enterprise">
      <div style="width: 1200px;height: 59px;position: relative;">
<!--        <img style="height: 59px;margin-bottom: 20px;width: 100%;margin-bottom: 24px;"-->
<!--             src="../assets/indexEnterprise.png"/>-->
        <div style="height: 59px;margin-bottom: 20px;width: 100%;background: linear-gradient(to right,#E0F0FF,#fff)"></div>
        <div style="font-size: 18px;position: absolute;top: 17px;left: 32px;font-weight: 550;">热门企业</div>
      </div>
      <div style="overflow: hidden;margin-top: 24px;">
        <div v-for="(item,index) in companyList" class="enterprise-box"
             :class="index===3||index===7||index===11?'enterprise-box-active':''" :key="index">
          <img src="../assets/index-comp.png" style="width: 286px;height: 195px;" alt="">
          <div class="enterprise-top" @click="enterpriseDetails(item.id)">
            <img v-if="item.logoUrl!=''" :src="item.logoUrl"/>
            <img v-if="item.logoUrl==''" src="../assets/ping.png"/>
            <div class="enterprise-name">
              <div class="enterprise-names">{{ item.name }}</div>
              <img src="../assets/index-line.png" style="width:30px;height:3px;margin-bottom: 5px;" alt="">
              <div class="enterprise-label">
                <div>{{ item.nature }}</div>
                <div>{{ item.scale }}</div>
                <div>{{ item.trade }}</div>
              </div>
            </div>
          </div>
          <div class="enterprise-bottom" v-if="companyList.length!==0">
            <div class="enterprise-job" v-for="(items,indexs) in companyList[index].jobList"
                 @click="jobDetails(items.id)" :key="indexs">
              <div>{{ items.name }}</div>
              <div>{{ items.address }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 企业列表 -->

    <!-- 热门职位旧——王 -->
<!--    <div class="hots">-->
<!--      <img src="../assets/index5.png" style="width: 1200px;" alt="">-->
<!--      <div class="hots-title">热门职位</div>-->
<!--      <div class="index-hots-contents">-->
<!--        <div class="hots-left">-->
<!--          <div v-for="(item,index) in tradeList" class="hots-left-label" :key="index"-->
<!--               @mouseenter="changePosition(index)">-->
<!--            <div :class="index==tradeListIndex ? 'active' : ''">{{ item.name }}</div>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="hots-right" :key="freshKey" v-if="tradeList.length!=0">-->
<!--          <div class="hots-right-box" v-for="(item,index) in tradeList[tradeListIndex].list" :key="index">-->
<!--            <div class="hots-right-h1">{{ item.name }}</div>-->
<!--            <div class="hots-right-cont">-->
<!--              <div v-for="(items,indexs) in tradeList[tradeListIndex].list[index].list" :key="indexs"-->
<!--                   @click="searchs(items.name)">{{ items.name }}-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
    <!-- 热门职位旧——王 -->
  </div>
</template>

<script>

import request from '../util/request.js'
// import Vue from 'vue'
export default {
  data () {
    return {
      active: null,
      tradeList: [],
      companyList: [],
      jobTradeList: [],
      swiperList: [],
      jobList: [],
      jobIndex: 0,
      tradeListIndex: 0,
      keywords: '',
      freshKey: 1,
      checkRefreshBtn: true,
      // url: '/static/img/refresh_btn.6f59e8a.png',
      // url: '../assets/refresh_btn.png',
      url: require('../assets/refresh_btn.png'),
      iscodeBtn: false,
      isLogin: false,
      userInfo: {},
      randKey: ''
    }
  },
  beforeCreate () {
    this.$nextTick(() => {
      this.getData()
      // this.getList()
    })
    var that = this
    var token = localStorage.getItem('token')
    if (token !== null) {
      request({
        method: 'post',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          token: '',
          Bearer: localStorage.getItem('token')
        },
        url: `/web/user`,
        data: JSON.stringify({})
      }).then(
        (res) => {
          if (res.data.code === 200) {
            that.userInfo = res.data.data.userInfo
            that.isLogin = res.data.data.isLogin
          }
        },
        (err) => {
          // console.log(err)
          if (err === 'token过期') {
            console.log(err)
          } else {
            that.$message.error(err)
          }
        }
      )
    }
  },
  created () {
    this.active = this.$route.query.active
  },
  // mounted() {
  //   var mySwiper = new Swiper('.swiper',{
  //     slidesPerView: 3,
  //     speed:100,
  //     delay: 2000,
  //     direction: getDirection(),
  //     navigation: {
  //       nextEl: '.swiper-button-next',
  //       prevEl: '.swiper-button-prev',
  //     },
  //     on: {
  //       resize: function () {
  //         swiper.changeDirection(getDirection());
  //       },
  //     },
  //   })
  // },
  methods: {
    getData () {
      var that = this
      request({
        method: 'post',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          token: '',
          Bearer: localStorage.getItem('token')
        },
        url: '/web/index',
        data: JSON.stringify({})
      }).then(
        (res) => {
          that.tradeList = res.data.data.tradeList
          that.companyList = res.data.data.companyList
          that.jobTradeList = res.data.data.jobTradeList
          that.swiperList = res.data.data.swiperList
          that.jobList = res.data.data.jobList
        },
        (err) => {
          that.$message.error(err)
        }
      )
    },
    getList () {
      var that = this
      request({
        method: 'post',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          token: '',
          Bearer: localStorage.getItem('token')
        },
        url: `/web/index/searchJobList`,
        data: JSON.stringify({})
      }).then(
        (res) => {
          that.jobList = res.data.data.jobList
        },
        (err) => {
          that.$message.error(err)
        }
      )
    },
    changePosition (e) {
      this.tradeListIndex = e
      this.freshKey = new Date().getTime()
    },
    changeIndustry (e) {
      this.jobIndex = e
    },
    search () {
      this.$router.push({
        path: '/search',
        query: {
          keywords: this.keywords
        }
      })
    },
    searchs (e) {
      this.$router.push({
        path: '/search',
        query: {
          keywords: e
        }
      })
    },
    jobDetails (id) {
      this.$router.push({
        path: '/jobDetails',
        query: {
          id: id
        }
      })
    },
    enterpriseDetails (id) {
      this.$router.push({
        path: '/enterpriseDetails',
        query: {
          id: id
        }
      })
    },
    goFor (e, id, url) {
      console.log(e, id, url)
      if (e === 1) {
        this.$router.push({
          path: '/enterpriseDetails',
          query: {
            id: id
          }
        })
      } else if (e === 2) {
        this.$router.push({
          path: '/jobDetails',
          query: {
            id: id
          }
        })
      } else if (e === 3) {
        window.open(url)
      }
    },
    changeFun (e) {
      var myOl = this.$refs.myOl.children
      var array = Array.from(myOl)

      for (let i = 0; i < array.length; i++) {
        var changE = e
        if (i === changE) {
          array[i].style.zIndex = 1
          array[i].style.opacity = 1
          array[i].style.height = 410 + 'px'
        } else {
          array[i].style.opacity = 0
          array[i].style.zIndex = 0
          array[i].style.height = 0 + 'px'
        }
      }
      // let activeIndex = that.$refs.carousel.activeIndex
      // console.log(activeIndex)
      // console.log(myOl)
    },
    getCode (e) {
      const that = this
      that.iscodeBtn = true
      request({
        method: 'post',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          token: '',
          Bearer: localStorage.getItem('token')
        },
        url: `/qrcode/getQrCode`,
        data: JSON.stringify({})
      }).then(
        (res) => {
          that.url = res.data.data.qrCode
          that.randKey = res.data.data.randKey
          that.num = 0
          // that.iscode = true
          that.checkRefresh = false
          this.loginState()
          that.timerchecks = setInterval(() => {
            // this.getUser()
            this.loginState()
          }, 60000)
        },
        (err) => {
          that.$message.error(err)
        }
      )
    },
    loginState () {
      var that = this
      if (that.num <= 4) {
        request({
          method: 'post',
          headers: {
            'Content-Type': 'application/json; charset=utf-8',
            token: '',
            Bearer: localStorage.getItem('token')
          },
          url: `/qrcode/check`,
          data: JSON.stringify({
            randKey: that.randKey
          })
        }).then(
          (res) => {
            var status = res.data.data.status
            if (res.data.code === 200) {
              if (status === 2) { // 过期 // 灰色
                that.iscodeBtn = false
                that.url = require('../assets/refresh_btn.png')
                clearInterval(that.timerchecks)
              } else if (status === 3) { // 成功
                that.num = that.num + 1
                var token = res.data.data.token
                that.iscode = false
                localStorage.setItem('token', token)
                that.$message.success('登录成功！')
                clearInterval(that.timerchecks)
                that.getUser()
              }
            }
          },
          (err) => {
            that.$message.error(err)
          }
        )
      }
    },
    getUser () {
      var that = this
      if (that.isLogin === false) {
        request({
          method: 'post',
          headers: {
            'Content-Type': 'application/json; charset=utf-8',
            token: '',
            Bearer: localStorage.getItem('token')
          },
          url: `/web/user`,
          data: JSON.stringify({})
        }).then(
          (res) => {
            if (res.data.code === 200) {
              that.userInfo = res.data.data.userInfo
              that.isLogin = res.data.data.isLogin
              if (that.userInfo.identity === 2) {
                that.$router.push('/jobLists')
              }
              if (that.userInfo.identity !== 2) {
                that.$router.push('/personalCore')
              }
            }
          },
          (err) => {
            // console.log(err)
            if (err === 'token过期') {
              console.log(err)
              localStorage.removeItem('token')
            } else {
              that.$message.error(err)
            }
          }
        )
      }
    },
    resume () { // 个人中心-个人简历
      if (this.userInfo.isResume === false) {
        this.$router.push({ path: '/editResume' })
      } else {
        this.$router.push({ path: '/resume' })
      }
    },
    personalCore () { // 个人中心——个人中心
      this.$router.push({ path: '/personalCore' })
    },
    enroll () { // 个人中心——我的投递
      this.$router.push({ path: '/myEnroll' })
    },
    go () { // 个人中心——我的收藏
      // this.$router.push({ path: '/myCollection' })
      this.$router.push({path: '/myEnroll', query: { change: '2' }})
    },
    goJoblist () { // 企业中心——职位列表
      this.$router.push({ path: '/jobLists' })
    },
    goCurriculumVitae () { // 企业中心——简历管理
      this.$router.push({ path: '/curriculumVitae' })
    },
    postRelease () {
      this.$router.push({ path: '/releaseJob' })
    },
    goss () { // 企业信息
      this.$router.push({ path: '/enterpriseInformation' })
    },
    goSearch () { // 跳转职位推荐
      this.$router.push({ path: '/search' })
    },
    goSearchs (id, name) { // 跳转职位推荐 传参name id
      // this.$router.push({path: '/search', query: { id, name }})
      this.$router.push({name: 'search', params: {id: id, name: name}})
    }
  }
}
</script>

<style>
@import url("../../node_modules/swiper/swiper.css");

* {
  padding: 0;
  margin: 0;
}

.el-carousel__item img {
  color: #475669;
  /*width: 100%;*/
  height: 410px;
  opacity: 1;
  line-height: 309px;
  margin: 0;
}

/* 导航栏 */
.indexs {
  width: 100%;
  padding-bottom: 20px;
}

/* 搜索 */
.search {
  width: 1200px;
  /*overflow: hidden;*/
  margin: 0 auto;
  margin-top: 15px;
}

.search-left {
  float: left;
  width: 785px;
}

.search-int {
  overflow: hidden;
  background-color: #fff;
  border-radius: 26px;
  width: 785px;
  height: 52px;
  line-height: 52px;
  box-shadow: 0px 0px 1px #cacaca;
}

.search-int input {
  float: left;
  font-size: 14px;
  color: #585555;
  height: 52px;
  line-height: 52px;
  width: 676px;
  border: none;
  outline-style: none;
  padding-left: 18px;
  border-radius: 26px;
  padding-right: 91px;
}

.search-int div {
  float: right;
  height: 40px;
  line-height: 40px;
  margin-top: 6px;
  margin-right: 9px;
  background-color: #587CF7;
  color: #fff;
  width: 82px;
  border-radius: 20px;
  text-align: center;
  font-size: 16px;
  margin-left: -91px;
  cursor: pointer;
}

.search-history {
  overflow: hidden;
  margin-top: 20px;
  width: 835px;
  height: 26px;
}

.search-history div {
  float: left;
  font-size: 14px;
  color: #9C9C9C;
  margin-left: 10px;
  cursor: pointer;
  margin-bottom: 8px;
}
.search-img-indexvue {
  float: left;
  width: 143px;
  height: 52px;
  margin-top: 7.5px;
  margin-right: 43px;
  margin-left: 31px;
  cursor: pointer;
}
.searchImgOne_indexvue:hover .index-head-code_indexvue{
  display: block;
}
.searchImgTwo_indexvue:hover .index-head-code_indexvue{
  display: block;
}
.search-img-indexvue:last-child {
  margin-right: 0;
  margin-left: 0;
}
/* 行业 */
.industry {
  width: 1200px;
  margin: 0 auto;
  /*height: 90px;*/
  height: 93px;
  border-radius: 5px;
  overflow: hidden;
  background-color: #fff;
  margin-top: 35px;
}

.industry-box {
  float: left;
  width: 200px;
  height: 90px;
  overflow: hidden;
  cursor: pointer;
}

.industry-box img {
  width: 50px;
  height: 50px;
  float: left;
  margin-left: 44px;
  margin-top: 20px;
  margin-right: 4px;
}

.industry-box div {
  float: left;
  font-size: 14px;
  line-height: 90px;
  color: #6D6D6D;
  width: 75px;
  height: 90px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* 岗位列表 */
.position {
  width: 1200px;
  margin: 0 auto;
  /*margin-top: 24px;*/
  overflow: hidden;
}

.position-box {
  float: left;
  margin-top: 20px;
  margin-right: 24px;
  position: relative;
  box-shadow: 0 1px 8px 2px #ebebeb;
  border-radius: 10px;
  width: 384px;
  height: 214px;
}

.position-top {
  width: 384px;
  position: absolute;
  top: 24px;
  padding-bottom: 18px;
  border-bottom: 1px dashed #DBDBDB;
  cursor: pointer;
}

.position-name {
  overflow: hidden;
}

.position-name div:first-child {
  float: left;
  font-weight: 500;
  margin-left: 15px;
  font-size: 18px;
  width: 11em;
  text-wrap: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.position-name div:last-child {
  float: right;
  color: #F38B4F;
  margin-right: 16px;
  font-size: 18px;
}

.position-address {
  color: #838383;
  text-align: left;
  margin-top: 9px;
  font-size: 12px;
  margin-left: 15px;
}

.position-label {
  overflow: hidden;
  margin-top: 15px;
  margin-left: 15px;
  margin-right: 15px;
  height: 20px;
}

.position-label div {
  float: left;
  margin-right: 5px;
  font-size: 12px;
  background-color: #EEF8FE;
  color: #2C94FF;
  border-radius: 5px;
  padding: 1px 6px;
  margin-bottom: 10px;
}

.position-bottom {
  width: 384px;
  position: absolute;
  top: 126px;
  margin-top: 15px;
  cursor: pointer;
}

.position-bottom-img {
  float: left;
  width: 52px;
  height: 52px;
  margin-right: 15px;
  margin-left: 15px;
}

.position-bottom-img img {
  width: 100%;
  height: 100%;
  border-radius: 9px;
}

.position-enterprise {
  float: left;
  width: 78%;
  margin-top: 4px;
}

.position-enterprise-name {
  font-size: 12px;
}

.position-enterprise-label {
  overflow: hidden;
  margin-top: 6px;
}

.position-enterprise-label div {
  float: left;
  font-size: 12px;
  color: #818181;
  margin-right: 5px;
}

/* 企业 */
.enterprise {
  overflow: hidden;
  width: 1200px;
  margin: 0 auto;
  margin-top: 24px;
}

.enterprise-box {
  width: 286px;
  height: 195px;
  float: left;
  position: relative;
  margin-right: 18px;
  margin-bottom: 16px;
}

.enterprise-box-active {
  margin-right: 0;
}

.enterprise-top {
  overflow: hidden;
  position: absolute;
  top: 27px;
  margin-left: 20px;
  padding-bottom: 14px;
  border-bottom: 1px dashed #DBDBDB;
  cursor: pointer;
}

.enterprise-top img {
  float: left;
  width: 59px;
  height: 59px;
  margin-right: 16px;
  border-radius: 4px;
}

.enterprise-name {
  float: left;
  width: 169px;
  height: 59px;
}

.enterprise-names {
  font-weight: 550;
  font-size: 16px;
  height: 22px;
  overflow: hidden;
  margin-bottom: 5px;
  width: 169px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.enterprise-line {
  width: 30px;
  height: 1px;
  margin-bottom: 10px;
}

.enterprise-label {
  overflow: hidden;
  height: 20px;
  width: 169px;
}

.enterprise-label div {
  display: inline-block;
  font-size: 12px;
  color: #8B8B8B;
}

.enterprise-bottom {
  position: absolute;
  top: 118px;
  width: 251px;
  left: 20px;
  cursor: pointer;
}

.enterprise-job {
  overflow: hidden;
  font-size: 12px;
  margin-bottom: 11px;
}

.enterprise-job div:first-child {
  float: left;
  text-align: left;
  font-size: 14px;
  width: 126px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.enterprise-job div:last-child {
  float: right;
  color: #A9A9A9;
}

/* 热门职位 底部注释*/
/*.hots {*/
/*  width: 1200px;*/
/*  margin: 0 auto;*/
/*  background-color: #fff;*/
/*  margin-top: 24px;*/
/*  margin-bottom: 20px;*/
/*  position: relative;*/
/*}*/

/*.hots-title {*/
/*  font-weight: 550;*/
/*  margin-left: 32px;*/
/*  font-size: 18px;*/
/*  position: absolute;*/
/*  top: 14px;*/
/*}*/

/*.index-hots-contents {*/
/*  overflow: hidden;*/
/*  z-index: 996;*/
/*  position: absolute;*/
/*  top: 55px;*/
/*  width: 1200px;*/
/*}*/

/*.hots-left {*/
/*  float: left;*/
/*  width: 218px;*/
/*  margin-right: 30px;*/
/*}*/

/*.hots-left-label div {*/
/*  color: #868686;*/
/*  height: 39px;*/
/*  line-height: 39px;*/
/*  font-size: 14px;*/
/*  padding-left: 40px;*/
/*  cursor: pointer;*/
/*}*/

/*.hots-left .active {*/
/*  background-color: #F2F7FF;*/
/*  color: #027FFE;*/
/*}*/

/*.hots-right {*/
/*  float: left;*/
/*  width: 78%;*/
/*  font-size: 14px;*/
/*  height: 557px;*/
/*  margin-bottom: 10px;*/
/*  overflow-y: auto;*/
/*}*/

/*.hots-right-box {*/
/*  margin-top: 18px;*/
/*}*/

/*.hots-right-box:first-child {*/
/*  margin-top: 0;*/
/*}*/

/*.hots-right-h1 {*/
/*  text-align: left;*/
/*  font-weight: 550;*/
/*  font-size: 16px;*/
/*  margin-bottom: 18px;*/
/*}*/

/*.hots-right-cont {*/
/*  font-size: 14px;*/
/*  overflow: hidden;*/
/*}*/

/*.hots-right-cont div {*/
/*  color: #A1A1A1;*/
/*  float: left;*/
/*  margin-right: 20px;*/
/*  font-size: 14px;*/
/*  margin-bottom: 17px;*/
/*  cursor: pointer;*/
/*}*/

/**/
/* 首页上方轮播 */
/*........................*/
input::-webkit-input-placeholder {
  color: #ccc
}

input:-moz-placeholder,
input::-moz-placeholder {
  color: #ccc
}

input:-ms-input-placeholder {
  color: #ccc
}

li,
ul {
  list-style: none
}

a {
  text-decoration: none
}

/* 首页上方轮播 */
:root {
  --swiper-theme-color: #f80;
}

.swiper {
  margin-left: auto;
  margin-right: auto;
  position: relative;
  overflow: hidden;
  list-style: none;
  padding: 0;
}

.swiper-vertical > .swiper-wrapper {
  flex-direction: column
}

.swiper-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  transition-property: transform;
  box-sizing: content-box;
  cursor: pointer !important;
}

.swiper-slide {
  flex-shrink: 0;
  width: 100%;
  position: relative;
}

.swiper-slide img {
  display: block;
  width: 100%;
}

.swiper-pagination {
  position: absolute;
  text-align: center;
  bottom: 10px;
  width: 100%;
  z-index: 1;
}

.swiper-pagination-bullet {
  /* 下方导航轮播小点 */
  width: var(--swiper-pagination-bullet-width, var(--swiper-pagination-bullet-size, 8px));
  height: var(--swiper-pagination-bullet-height, var(--swiper-pagination-bullet-size, 8px));
  display: inline-block;
  border: 1px solid #fff;
  border-radius: 50%;
  background: var(--swiper-pagination-bullet-inactive-color, #fff);
  opacity: var(--swiper-pagination-bullet-inactive-opacity, .8);
  cursor: pointer;
}

.swiper-pagination-bullet-active {
  /* 下方导航轮播小点选中状态 */
  opacity: var(--swiper-pagination-bullet-opacity, 0.8);
  border: 1px solid #f80;
  background: var(--swiper-pagination-color, var(--swiper-theme-color))
}

.swiper-pagination-bullet {
  margin: 0 var(--swiper-pagination-bullet-horizontal-gap, 4px)
}

.job-menu {
  float: left;
  position: relative;
  width: 238px;
  height: 410px
}

.swiper-menu-bg img {
  width: auto;
  height: 100%;
}

.job-menu__list {
  width: 238px;
  height: 410px;
  padding-top: 16px;
  padding-bottom: 16px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2
}

.job-menu__list--backdrop-filter {
  background: rgba(59, 67, 77, .2);
}

@supports ((-webkit-backdrop-filter:blur(35px)) or (backdrop-filter:blur(35px))) {
  .job-menu__list--backdrop-filter {
    /*毛玻璃*/
    background: rgba(79, 90, 102, .6);
    -webkit-backdrop-filter: blur(35px);
    backdrop-filter: blur(35px);
  }
}

.job-menu__item {
  height: 42px;
  padding-left: 24px;
  padding-right: 16px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  cursor: pointer
}

.job-menu__item:hover {
  background: rgba(0, 0, 0, .2)
}

.job-menu__item:hover .job-menu__sub {
  display: block
}

.job-menu__item__name {
  display: block;
  float: left;
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #fff;
  line-height: 20px;
  width: 162px;
  margin-top: 11px;
  white-space: nowrap;
  -o-text-overflow: ellipsis;
  text-overflow: ellipsis;
  overflow: hidden
}

.job-menu__item__name:hover {
  color: #fff
}

.job-menu__item__arrow-right {
  display: block;
  float: left;
  width: 12px;
  height: 12px;
  background: url(//fecdn5.zhaopin.cn/www_zhaopin_com/assets/icon_triangle_r_white.962e68.png) no-repeat 50%;
  background-size: 12px 12px;
  margin-top: 15px;
  margin-left: 24px
}

.job-menu__sub {
  display: none;
  position: absolute;
  top: 0;
  left: 238px;
  z-index: 1;
  width: 700px;
  height: 410px;
  padding: 16px 23px 0 24px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  background: #fff;
  overflow-y: auto;
}

.job-menu__sub::-webkit-scrollbar {
  width: 14px;
  height: 14px;
}

.job-menu__sub::-webkit-scrollbar-track,
.job-menu__sub::-webkit-scrollbar-thumb {
  border-radius: 999px;
  border: 5px solid transparent;
}

.job-menu__sub::-webkit-scrollbar-track {
  box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.2) inset;
}

.job-menu__sub::-webkit-scrollbar-thumb {
  min-height: 20px;
  background-clip: content-box;
  box-shadow: 0 0 0 5px rgba(0, 0, 0, 0.2) inset;
}

.job-menu__sub::-webkit-scrollbar-corner {
  background: transparent;
}
.job-menu__sub__title {
  padding: 11px 0 11px 8px;
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #222;
  line-height: 20px;
  cursor: auto;
  -webkit-box-sizing: initial;
  box-sizing: initial;
  font-weight: bold;
}

.job-menu__sub__list {
  overflow: hidden;
  margin-top: 14px
}

.job-menu__sub__name {
  display: block;
  float: left;
  width: 158px;
  /*height: 32px;*/
  padding: 0 6.5px;
  margin-right: 1px;
  font-size: 14px;
  font-weight: 400;
  color: #666;
  line-height: 32px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  white-space: nowrap;
  -o-text-overflow: ellipsis;
  text-overflow: ellipsis;
  overflow: hidden
}

.job-menu__sub__name:hover {
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #5b7be9;
  text-wrap: wrap;
}

.banner-main {
  float: left
}

.banner-main__wrap {
  position: relative;
  width: 700px;
  height: 410px;
  overflow: hidden
}

/*@-webkit-keyframes refresh-rotate {*/
/*  0% {*/
/*    -webkit-transform: rotate(0deg);*/
/*    transform: rotate(0deg)*/
/*  }*/

/*  to {*/
/*    -webkit-transform: rotate(1turn);*/
/*    transform: rotate(1turn)*/
/*  }*/
/*}*/

/*@keyframes refresh-rotate {*/
/*  0% {*/
/*    -webkit-transform: rotate(0deg);*/
/*    transform: rotate(0deg)*/
/*  }*/

/*  to {*/
/*    -webkit-transform: rotate(1turn);*/
/*    transform: rotate(1turn)*/
/*  }*/
/*}*/

/*.home-page {*/
/*  width: 100%;*/
/*  background-image: url(//fecdn5.zhaopin.cn/www_zhaopin_com/assets/bg_main.68c837.png?x-oss-process=image%2Fquality%2Cq_80), url(//fecdn5.zhaopin.cn/www_zhaopin_com/assets/bg_main_repeat.a42224.png?x-oss-process=image%2Fquality%2Cq_80);*/
/*  background-position: top 0 center, top 0 center;*/
/*  background-size: 2000px 350px, 10px 350px;*/
/*  background-repeat: no-repeat, repeat-x;*/
/*  background-color: #f7fbff;*/
/*  position: relative*/
/*}*/
.sccanCode_login {
  float: left;
}

.sccanCode_login_box {
  width: 260px;
  height: 410px;
  background: url("../assets/sccanCode_login_box_bg.png") no-repeat;
  background-size: 100% 100%;
  padding-top: 50px;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
}

.sccanCode_title {
  width: 4em;
  font-size: 16px;
  font-weight: bold;
  height: 30px;
  /*line-height: 22px;*/
  /*padding-bottom: 4px;*/
  border-bottom: 3px solid #587CF7;
  margin: 0 auto;
  margin-bottom: 28px;
}

.sccanCode_login_code {
  width: 132px;
  height: 132px;
  margin: 0 auto;
  margin-bottom: 43px;
  position: relative;

}

.sccanCode_login_code img {
  width: 100%;
  height: 100%;
  border-radius: 5px;
  box-shadow: 0 3px 6px 0 rgba(165, 161, 161, 0.5);
}

.refresh_title {
  font-size: 14px;
  height: 20px;
  line-height: 20px;
  margin-bottom: 9px;
  text-align: center;
}

.sccanCode_refreshBtn {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(220, 220, 220, 0.8);
  border-radius: 5px;
}
.job-menu{
  float: left;
  position: relative;
}
.job-menu__bj__list {
  height: 410px;
  background: rgba(79, 90, 102, .6);
}
.job-menu_bj_item-active {
  opacity: 1 !important;
}
.job-menu__bj__item {
  position: relative;
  float: left;
  width: 238px;
  height: 410px;
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: 700px 410px;
  opacity: 0;
}
.index-head-code_indexvue{
  position: absolute;
  width: 179px;
  height: 205px;
  background-color: #fff;
  text-align: center;
  border-radius: 5px;
  z-index: 2;
  border-radius: 10px;
  top: 52px;
  display: none;
}
.index-head-code-img1_indexvue{
  width: 150px;
  height: 150px;
  margin-top: 14px;
}
.index-head-code-triangle_indexvue{
  width: 0px;
  height: 0px;
  border: 10px solid transparent;
  border-bottom-color: #fff;
  margin-top: -20px;
  margin-left: 79.5px;
}
.index-head-code-div_indexvue{
  color: #9B9B9B;
  font-size: 14px;
}
.morebtn_indexvue{
  background: #fff;
  width: 196px;
  height: 47px;
  line-height: 47px;
  text-align: center;
  color: #FF8C41;
  font-size: 16px;
  margin: 0 auto;
  margin-top: 24px;
  margin-bottom: 24px;
  border-radius: 5px;
  -webkit-box-shadow: 0 2px 4px 0 rgba(184,180,180,0.5);
  box-shadow: 0 2px 4px 0 rgba(184,180,180,0.5);
  cursor: pointer;
}
/*2023116*/
.home-sider {
  width: 384px;
  /*position: absolute;*/
  /*left: 0;*/
  /*top: 0;*/
}
.home-job-menu {
  color: #666;
  position: relative;
  z-index: 1002;
  background: #fff;
  border-radius: 12px;
  padding: 6px 0 0 0;
}
.home-job-menu .job-menu-wrapper {
  height: 289px;
  padding: 0 3px;
  overflow: hidden;
}
.home-job-menu dl {
  height: 22px;
  transition: all .2s linear;
  border-radius: 8px;
  padding: 9px 17px;
}
.home-job-menu dl.hide {
  display: none
}

.home-job-menu dd b {
  float: left;
  font-size: 16px;
  font-weight: 500;
  color: #222;
  line-height: 22px
}

.home-job-menu dd i {
  float: right;
  width: 4px;
  height: 7px;
  margin-top: 7px;
  background: url(https://img.bosszhipin.com/static/file/2022/01vcskhm8y1652252017628.png) -6px -16px/10px auto no-repeat
}

.home-job-menu dd i:before {
  content: none
}

.home-job-menu dl {
  height: 22px;
  transition: all .2s linear;
  border-radius: 8px;
  padding: 9px 17px
}

.home-job-menu dl:hover {
  box-shadow: 0 4px 16px 0 rgba(153,153,153,.2)
}

.home-job-menu dl:hover dd i {
  background-position: -6px -8px
}

.home-job-menu dd {
  position: relative;
  height: 22px;
}
.home-job-menu dd {
  position: relative;
  height: 22px;
  line-height: 22px;
  overflow: hidden;
}
.home-job-menu dd i {
  float: right;
  width: 4px;
  height: 7px;
  margin-top: 7px;
  background: url(https://img.bosszhipin.com/static/file/2022/01vcskhm8y1652252017628.png) -6px -16px/10px auto no-repeat;
}
.home-job-menu dd i:before {
  content: none
}

.home-job-menu dd b {
  float: left;
  font-size: 16px;
  font-weight: 500;
  color: #222;
  line-height: 22px;
}
.home-job-menu dl:hover .menu-sub {
  display: block
}
.home-job-menu a {
  display: inline-block;
  font-size: 14px;
  font-weight: 400;
  color: #666;
  height: 22px;
  line-height: 22px;
  margin-left: 20px;
}
.home-body-wrapper .menu-sub {
  border-radius: 12px;
}
.home-job-menu .menu-sub {
  /* display: block; */
  position: absolute;
  top: 0;
  left: 388px;
  padding: 16px 8px 10px 16px;
  margin-top: 0;
  width: 772px;
  height: 314px;
  overflow: overlay;
  overflow: auto;
  z-index: 1;
  background: #fff;
  box-shadow: 0 10px 40px 0 rgba(153,153,153,.2);
  border-radius: 12px;
  border: 1px solid #ebeef5;
}
.menu-sub {
  display: none;
  position: absolute;
  background: #fff;
  padding: 20px 30px 20px 10px;
  width: 648px;
  top: 0;
  margin-top: -10px;
  left: 100%;
  z-index: 1;
  box-shadow: 0 1px 6px rgba(6,0,1,.1);
}
.home-job-menu .menu-sub .menu-article {
  font-size: 16px;
  font-weight: 500;
  color: #12141a;
  line-height: 22px;
  height: auto;
  padding-left: 0;
  margin-bottom: 4px;
  display: none;
}
.menu-sub .menu-article {
  padding-left: 20px;
  height: 30px;
  font-size: 15px;
  font-weight: 700;
  color: #222;
}
.home-job-menu .menu-sub h4 {
  float: left;
  width: 118px;
  padding-top: 12px;
  margin: 0;
  padding-left: 0;
  font-size: 13px;
  font-weight: 400;
  color: #666;
  line-height: 18px;
  display: none;
}
.menu-sub h4 {
  float: left;
  width: 104px;
  color: #666;
  font-size: 13px;
  padding-top: 2px;
  font-weight: 400;
  padding-left: 20px;
}
.menu-sub .text {
  margin-left: 130px;
  border-bottom: solid 1px #f5f6f9;
  padding: 0 0 10px 1px;
}
.home-job-menu .menu-sub .text a {
  margin-left: 0;
  margin-right: 20px;
  margin-bottom: 6px;
  margin-top: 6px;
  color: #222;
  font-size: 13px;
  height: 18px;
  line-height: 18px;
}
.menu-sub .text a {
  margin-left: 0;
  margin-right: 25px;
  color: #222;
}
.home-job-menu a {
  display: inline-block;
  font-size: 14px;
  font-weight: 400;
  color: #666;
  height: 22px;
  line-height: 22px;
  margin-left: 20px;
}
.home-job-menu .job-menu-page {
  position: relative;
  height: 44px;
  padding: 0 20px;
  border-top: 1px dashed #e6e6e6;
  overflow: hidden;
}
.home-job-menu .menu-page-info {
  float: left;
  font-size: 14px;
  font-weight: 500;
  color: #00a6a7;
  line-height: 20px;
  margin-top: 12px;
}
em {
  font-style: normal;
}
.home-job-menu .menu-page-controller {
  float: right;
  margin-top: 10px;
}
.home-job-menu .menu-page-btn.menu-page-prev {
  transform: rotate(180deg);
}
.home-job-menu .menu-page-btn {
  float: left;
  width: 24px;
  height: 24px;
  background: rgba(0,190,189,.1);
  border-radius: 6px;
  color: #00bebd;
  transition: all .2s linear;
  margin-left: 12px;
  text-align: center;
  line-height: 24px;
  cursor: pointer;
}
.home-job-menu .menu-page-btn i {
  display: block;
  width: 5px;
  height: 8px;
  margin: 8px auto 0;
  background: url(https://img.bosszhipin.com/static/file/2022/01vcskhm8y1652252017628.png) -5px 0/10px auto no-repeat;
}
.job-menu__sub__name:nth-child(12n){
  margin-bottom: 15px;
}
.sccanCode_login_box_role_page{
  float: left;
  padding: 28px 13px;
}
.sccanCode_login_box_role_page div{
  width: 110px;
  text-align: center;
  border: 1px solid #587CF7;
  border-radius: 5px;
  height: 32px;
  line-height: 32px;
  float: left;
  cursor: pointer;
}
.sccanCode_login_box_role_page div:first-child{
  margin-right: 8px;
}
.sccanCode_login_box_role{
  width: 260px;
  height: 410px;
  background: #fff;
  padding-top: 32px;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
}
.sccanCode_login_box_role img{
  float: left;
  width: 66px;
  height: 66px;
  border-radius: 50%;
}
.sccanCode_login_box_role-box-indexvue{
  float: left;
  margin-top: 5px;
  font-size: 16px;
  width: 128px;
}
.sccanCode_login_box_role-right-box{
  width: 100%;
  /*margin-top: 132px;*/
}
.sccanCode_role-right-boxs-indexvue{
  height: 110px;
  position: relative;
  cursor: pointer;
  text-align: center;
}
.sccanCode_role-right-boxs-indexvue img{
  width: 110px;
  height: 110px;
  border-radius: 11px;
}
.sccanCode_role-right-boxs-indexvue div{
  position: absolute;
  top: 70px;
  left: 23px;
  font-size: 16px;
}
.sccanCode_login_box_tipTime{
  float: left;
  width: 100%;
  padding: 9px 14px;
  color: #864421;
  font-size: 14px;
  border-bottom: 1px solid #E9E9E9;
}
.sccanCode_login_box_tipTime div{
  float: left;
}
.sccanCode_login_box_tipTime div:first-child{
  margin-right: 31px;
}
.ScancodeloginCompany_phone,.ScancodeloginPersonal_phone{
  float: left;
  width: 230px;
  height: 63px;
  margin: 20px 15px 0;
}
.ScancodeloginCompany_phone img,.ScancodeloginPersonal_phone img{
  width: 100%;
  height: 100%;
  border-radius: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/index.vue